/* Variant selector. Updates price and the add-to-cart state in place.
   No re-render, no fetch — every variant's data is already in the DOM. */
(function () {
  var root = document.querySelector('[data-variant-selector]');
  if (!root) return;

  var pdp    = document.querySelector('[data-pdp]');
  var atc    = pdp.querySelector('[data-atc]');
  var priceE = pdp.querySelector('.pdp__price');
  var sticky = pdp.querySelector('.stickybar__price');

  function money(paise) {
    // Shopify prices are in the shop's minor unit. Format for en-IN.
    return new Intl.NumberFormat('en-IN', {
      style: 'currency', currency: 'INR', maximumFractionDigits: 0
    }).format(paise / 100);
  }

  function render(input) {
    var price   = Number(input.dataset.price);
    var compare = Number(input.dataset.compare);
    var avail   = input.dataset.available === 'true';

    if (priceE) {
      var box = priceE.querySelector('.price');
      var tax = box.querySelector('.price__tax');
      var html = '';
      if (compare > price) {
        html += '<s class="data price__was">' + money(compare) + '</s>';
      }
      html += '<span class="data price__now">' + money(price) + '</span>';
      if (compare > price) {
        html += '<span class="chip price__save">' +
                box.dataset.saveLabel + ' ' + money(compare - price) + '</span>';
      }
      box.innerHTML = html + (tax ? tax.outerHTML : '');
    }
    if (sticky) {
      sticky.querySelector('.price').innerHTML =
        '<span class="data price__now">' + money(price) + '</span>';
    }

    atc.disabled = !avail;
    atc.textContent = avail ? atc.dataset.labelAdd : atc.dataset.labelOut;

    var url = new URL(window.location);
    url.searchParams.set('variant', input.value);
    window.history.replaceState({}, '', url);
  }

  // Labels come from locales via data attributes — never hardcoded here.
  root.addEventListener('change', function (e) {
    if (e.target.name === 'id') render(e.target);
  });
})();
